export const LimitAllowedIn = ["table"];